<template>
  <div
    class="project-structure-widget"
    >
    <div
      id="project-structure-widget-body"
      class="project-structure-widget-body"
      :style="plan?'padding: 0px; overflow: hidden;':'overflow: hidden;'"
      >
      <slot name="body"/>
    </div>
    <div class="project-structure-widget-header font-weight-normal">
      <slot name="header"/>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['plan'],
    data: () => ({
    }),
  }
</script>
<style>
  .project-structure-widget {
    position: relative;
    width: calc(50% - 5px);
    height: calc(50% - 5px);
    background-color: rgb(41,41,41);
    border-radius: 10px;
    padding: 5px;
  }
  .project-structure-widget-body {
    position: relative;
    width: 100%;
    height: calc(100% - 30px);
    background-color: rgb(30,30,30);
    /* border-radius: 10px 10px 0px 0px; */
    border-radius: 10px;
    padding: 5px;
  }
  .project-structure-widget-header {
    display: flex;
    width: 100%;
    height: 30px;
    justify-content: center;
    align-items: center;
    font-size: 20px;
  }
</style>
